import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GruppeTier } from '../classes/gruppe-tier';
import { Betriebskontakt } from '../../stammdaten/betriebskontakte/betriebskontakt';
import { GruppeTierService } from '../gruppe-tier.service';
import { MessageService } from '../../../services/message-service/message.service';

@Component({
    selector: 'kiene-gruppe-tier-kontakt-setzen-dialog',
    templateUrl: './gruppe-tier-kontakt-setzen-dialog.component.html',
    styleUrls: ['./gruppe-tier-kontakt-setzen-dialog.component.scss'],
})
export class GruppeTierKontaktSetzenDialogComponent {
    selectedKontakt: Betriebskontakt | null = null;
    isSaving = false;
    isMobileView = false;
    showSearchBlock = true;

    constructor(
        private readonly dialogRef: MatDialogRef<GruppeTierKontaktSetzenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { tiere: GruppeTier[]; gruppeId?: number },
        private readonly gruppeTierService: GruppeTierService,
        private readonly messageService: MessageService,
    ) {
        if (typeof window !== 'undefined') {
            this.isMobileView = window.matchMedia('(max-width: 600px)').matches;
        }
    }

    onKontaktSelected(kontakt: Betriebskontakt): void {
        this.selectedKontakt = kontakt;
        if (this.isMobileView) {
            this.showSearchBlock = false;
        }
    }

    onKontakteSelected(kontakte: Betriebskontakt[]): void {
        this.selectedKontakt = kontakte?.length > 0 ? kontakte[0] : null;
        if (this.isMobileView) {
            this.showSearchBlock = !this.selectedKontakt;
        }
    }

    openSearchBlock(): void {
        if (this.isMobileView) {
            this.showSearchBlock = true;
        }
    }

    isSearchVisible(): boolean {
        if (!this.isMobileView) {
            return true;
        }
        return !this.selectedKontakt || this.showSearchBlock;
    }

    isSelectedPreviewVisible(): boolean {
        return this.isMobileView && !!this.selectedKontakt && !this.showSearchBlock;
    }

    save(): void {
        if (!this.data?.tiere?.length) {
            this.messageService.errorMessage('Keine Tiere ausgewählt!', null);
            return;
        }

        this.isSaving = true;
        this.gruppeTierService
            .updateKontaktMultiple(this.data.tiere, {
                updateKontakt: true,
                kontaktId: this.selectedKontakt?.kunde_id ?? null,
                gruppeId: this.data.gruppeId,
            })
            .subscribe({
                next: success => {
                    this.isSaving = false;
                    if (!success) {
                        this.dialogRef.close(false);
                        return;
                    }

                    this.messageService.infoMessage(
                        this.selectedKontakt
                            ? 'Kontakt wurde für alle ausgewählten Tiere gesetzt.'
                            : 'Kontakt wurde für alle ausgewählten Tiere entfernt.',
                    );
                    this.dialogRef.close(true);
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Kontakt konnte nicht aktualisiert werden!', err);
                },
            });
    }

    cancel(): void {
        this.dialogRef.close(false);
    }
}
